import React, { useState, useEffect, useRef } from 'react';
import { CueTip } from '../../../components/Common/CueTooltip';
import FormHelper from '../../../components/FormBuilder/FormHelpers';
import moment from '../../../../node_modules/moment/min/moment.min.js'
import "react-datepicker/dist/react-datepicker.css";
import { FieldLabel, Description, RequiredMsg, FieldReview, FieldPoint } from '../FieldLabel';
import DatePicker from "react-datepicker";
import Cs from '../../../services/CommonService';

const InputDateTimePicker = ({ renderField, field, formData, readOnly, errors, formFn, isFormWizard, openFieldLabelModal, currentLocale, position, fieldReview, forceUpdate }) => {
  const clientId = field.client_id;
  const clientIdFormatDate = clientId + '_formatted_date';
  let dateFormat = "YYYY-MM-DD";
  if (field.component === 'timepicker') dateFormat = "YYYY-MM-DD HH:mm";

  let d = null;
  if (formData[clientIdFormatDate]) {
    d = moment(formData[clientIdFormatDate]).toDate();
  }

  const [value, setDate] = useState(d);
  const [showError, setShowError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    }
  }, [])

  if (!renderField) return null;

  const handleClick = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  }

  let inputAttributes = {
    'type': 'text',
    'id': clientId,
    'name': clientId,
    'placeholderText': field.placeholder,
    'className': 'form-input form-input-gray form-input-full',
    'showTimeSelect': (field.component === 'timepicker' && value) ? true : false,
    'timeIntervals': (field.component === 'timepicker' && value) ? 15 : null
  }

  let parentAttributes = {
    'tooltip': field.tooltip
  }

  let labelAttributes = FormHelper.setLabelStyle(field, isFormWizard, parentAttributes);

  const onDateChanged = (value) => {
    const dateStr = moment(value).format(field.dateFormat);
    /*if(FormHelper.confirmValue(field.reconfirm_value, dateStr, formCancelAlertLocale)){*/
    setIsOpen(false);
    formData[clientIdFormatDate] = moment(value).format(dateFormat);
    formData[clientId] = dateStr;
    setDate(value);
    const onSelectFn = formFn['on_select_' + clientId];
    onSelectFn && onSelectFn(value, formData[clientIdFormatDate]);
    onDateSelect();
    setError();
    forceUpdate();
    /*}*/
  }

  const onTimeChanged = (value) => {
    const dateStr = moment(value).format("HH:mm");
    formData[clientId] = dateStr;
    const splits = dateStr?.split(":");
    formData[clientId + 'obj'] = {
      hr: splits[0],
      min: splits[1]
    };
    setDate(value);
    setError();
  }

  formFn["update_" + clientId] = (date) => {
    const d = moment(date).toDate();
    onDateChanged(d);
  };

  //Common utility functions
  const getDate = (dateKey) => {
    return FormHelper.getValueFormKeys(dateKey + '_formatted_date', formData, formFn.foreignData);
  }

  const calcDateDiff = (startDateKey, endDateKey, diff, non_negative = false, add_decimal = false) => {
    const startDate = getDate(startDateKey);
    const endDate = getDate(endDateKey);
    return Cs.compareDate(endDate, startDate, diff, non_negative, add_decimal);
    //updateByModalName(targetKey, diffVal); //add to form builder
  }

  const add = (date, no, dwmy) => {
    const futureDate = moment(date).add(no, dwmy).format(dateFormat);
    return futureDate;
    //updateByModalName(targetKey, futureDate); 
    //formFn["update_"+targetKey](futureDate);
  }

  const subtract = (date, no, dwmy) => {
    const pastDate = moment(date).subtract(no, dwmy).format(dateFormat);
    return pastDate;
    //updateByModalName(targetKey, pastDate); 
    //formFn["update_"+targetKey](pastDate);
  }

  const updateByModalName = (targetKey, text) => {
    formFn["update_" + targetKey](text);
  }
  //

  const onDateSelect = () => {
    try {
      if (field.function_expression) {
        eval(field.function_expression);
      }
    } catch (e) {
      console.error(e.message)
    }
  }

  //FormHelper.setDisabled(field, inputAttributes);
  FormHelper.setDatePicker(field, inputAttributes);
  if (isOpen) {
    const setMinFn = formFn['set_min_' + clientId];
    const setMaxFn = formFn['set_max_' + clientId];
    setMinFn && setMinFn(inputAttributes);
    setMaxFn && setMaxFn(inputAttributes);
  }
  //FormHelper.checkFieldValidity(field, formData, errors);

  try {
    const setMinDate = (srcKey, dwmy, no) => {
      inputAttributes.minDate = Cs.addDwmyToDate(formData[srcKey + '_formatted_date'], dwmy, no, null, true);
    }

    const setMaxDate = (srcKey, dwmy, no) => {
      inputAttributes.maxDate = Cs.addDwmyToDate(formData[srcKey + '_formatted_date'], dwmy, no, null, true);
    }

    if (isOpen && field.init_expression) {
      eval(field.init_expression);
    }

    if (formFn["filter_" + clientId]) {
      inputAttributes.filterTime = (time) => formFn["filter_" + clientId](time);
    }

  } catch (e) {
    console.error(e.message)
  }

  const setError = () => {
    if (field.required) {
      errors[clientId].invalid = formData[clientId] == null ? true : false;
      errors[clientId].invalid = onValidateExp(formData);
      errors[clientId].touched = true;
      if (errors[clientId].invalid) {
        errors.invalid[clientId] = true;
      } else {
        delete errors.invalid[clientId];
      }
      setShowError(!showError);
      formFn.refreshFormSubmit();
    }
  }

  const onValidateExp = () => {
    try {
      if (field.validate_expression) {
        return eval(field.validate_expression);
      }
      return errors[clientId].invalid;
    } catch (e) {
      console.error(e.message);
    }
  }

  const Error = () => {
    if (field.required && (errors[clientId].touched || errors.isSubmitted) && errors[clientId].invalid) {
      return (
        <div className="errormsg">
          <div>
            <span className="fas fa-exclamation-triangle m-r-5" />
            <RequiredMsg {...{ field, currentLocale }} />
          </div>
        </div>
      )
    }
    return null;
  }

  return (
    <div ref={ref} {...parentAttributes}>
      <div className="flex coldir m-b-20 tooltip">
        <CueTip
          positionCss={position > 1 ? 'top' : 'bottom'}
          tooltip={field.tooltip}
          currentLocale={currentLocale}
          locale={field.locale?.tooltip} />
        <FieldLabel field={field}
          isFormWizard={isFormWizard}
          labelAttributes={labelAttributes}
          currentLocale={currentLocale}
          openFieldLabelModal={openFieldLabelModal} />
        {field.is_time_only ?
          <DatePicker selected={value}
            className="form-input form-input-gray form-input-full"
            onChange={(date) => onTimeChanged(date)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            timeCaption="Time"
            dateFormat="h:mm aa" />
          :
          <>
            <input className='form-input form-input-gray form-input-full'
              disabled={readOnly} value={formData[clientId] ? formData[clientId] : ''}
              onClick={handleClick} onChange={() => { }} inputMode="none" />
            {isOpen ?
              <DatePicker dateFormat={dateFormat} selected={value}
                onChange={date => onDateChanged(date)} dropdownMode="select"
                peekNextMonth showMonthDropdown showYearDropdown
                {...inputAttributes} shouldCloseOnSelect={true}
                inline />
              : null
            }
          </>
        }
        <FieldPoint userRefId={formFn.userRefId} clientId={clientId}
          point={field.point} currentLocale={currentLocale}
          negPoint={field.incorrect_point} />
        <Description description={field.description}
          currentLocale={currentLocale}
          locale={field.locale?.description} />
        <FieldReview review={fieldReview} />
        <Error />
      </div>
    </div>
  )

}

export default InputDateTimePicker;